import { render } from "./InvestorRelations.vue?vue&type=template&id=45d8b4f6&scoped=true"
import script from "./InvestorRelations.vue?vue&type=script&lang=js"
export * from "./InvestorRelations.vue?vue&type=script&lang=js"

import "./InvestorRelations.vue?vue&type=style&index=0&id=45d8b4f6&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d8b4f6"]])

export default __exports__